import { render, staticRenderFns } from "./StepA.vue?vue&type=template&id=d9a0c882&scoped=true"
import script from "./StepA.vue?vue&type=script&lang=js"
export * from "./StepA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a0c882",
  null
  
)

export default component.exports